import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "resume-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.252 6.04c0-1.747 1.88-2.955 3.418-1.95l.006.004 9.043 5.943c1.377.905 1.378 2.986-.003 3.89l-.002.001-9.034 5.94-.003.001c-1.542 1.015-3.425-.198-3.425-1.945V6.04Zm11.645 6.63-.002.002h-.002l-9.04 5.944-.003.002c-.427.279-1.098 0-1.098-.694V6.04c0-.694.672-.973 1.1-.692l.005.004 9.037 5.94c.476.312.476 1.067.003 1.38Z"
    }, null, -1),
    _createElementVNode("path", { d: "M4.248 4.525a.75.75 0 1 0-1.5 0v15a.75.75 0 0 0 1.5 0v-15Z" }, null, -1)
  ])))
}
export default { render: render }